import { disposableInterval, IDisposable } from "app/common/disposable";
import { ITimeSource } from "app/common/time_source";

export function initializeClock(elmt: JQuery<HTMLElement>, timeSource: ITimeSource, format?: string): IDisposable {
    updateClock(elmt, timeSource, format);
    return disposableInterval(() => updateClock(elmt, timeSource, format), 1000);
}

function updateClock(elmt: JQuery<HTMLElement>, timeSource: ITimeSource, format?: string) {
    const now = timeSource.now();
    elmt.text(now.format(format));
}
